export const GET_ACTIVITIES = "/hubspot/engagements";
export const ADD_ACTIVITY_NOTE = "hubspot/create_note";
